/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { secondsToHoursAndMinutes } from "utils/dateAndTime";
import SectionsCard from "../shared/tripReconiliation/SectionsCard";
import SummarySection from "../shared/tripReconiliation/SummarySection";

const TripSummary = ({ tripSummary }) => {
    const intl = useIntl();
    const items = useMemo(
        () => [
            {
                id: 1,
                title: <FormattedMessage id="trip.reconciliation.summary.operatingbymobile" />,
                value:
                    tripSummary?.operated_with === "system"
                        ? intl.formatMessage({ id: "yes" })
                        : intl.formatMessage({ id: "no" }),
            },
            {
                id: 2,
                title: <FormattedMessage id="trip.reconciliation.summary.distance" />,
                value: `${tripSummary?.manual_distance ?? 0} ${intl.formatMessage({ id: "km" })}`,
            },
            {
                id: 3,
                title: <FormattedMessage id="trip.reconciliation.summary.mobiledistance" />,
                value: `${tripSummary?.mobile_distance ?? 0} ${intl.formatMessage({ id: "km" })}`,
            },
            {
                id: 4,
                title: <FormattedMessage id="trip.reconciliation.summary.dropoffnum" />,
                value: `${tripSummary?.dropoffs_count || 0} ${intl.formatMessage({ id: "point" })}`,
            },
            {
                id: 5,
                title: <FormattedMessage id="trip.reconciliation.summary.tripperiod" />,
                value: `${tripSummary?.trip_duration ?? 0} ${intl.formatMessage({ id: "hour" })}`,
            },
            {
                id: 6,
                title: <FormattedMessage id="trip.reconciliation.summary.waitingtime" />,
                value: secondsToHoursAndMinutes(
                    +tripSummary?.dropoffs_offload_duration,
                    intl.formatMessage
                ),
            },
            {
                id: 7,
                title: <FormattedMessage id="trip.reconciliation.summary.geofencing" />,
                value: tripSummary?.geofence
                    ? intl.formatMessage({ id: "yes" })
                    : intl.formatMessage({ id: "no" }),
            },
            {
                id: 8,
                title: <FormattedMessage id="trip.reconciliation.summary.endtripbydriver" />,
                value: tripSummary?.auto_ending
                    ? intl.formatMessage({ id: "yes" })
                    : intl.formatMessage({ id: "no" }),
            },

            {
                id: 9,
                title: <FormattedMessage id="trip.reconciliation.summary.returnable" />,
                value: tripSummary?.returnable
                    ? intl.formatMessage({ id: "yes" })
                    : intl.formatMessage({ id: "no" }),
            },
        ],
        [intl.locale, tripSummary]
    );

    return (
        <SectionsCard title={<FormattedMessage id="trip.reconciliation.tip.summary" />}>
            {items.map((item, index) => (
                <SummarySection
                    key={item?.id}
                    item={item}
                    isLastSection={index === items.length - 1}
                />
            ))}
        </SectionsCard>
    );
};

export default TripSummary;
